const menuList = [
    {
        image: '/assets/img/icons/about-me.svg',
        label: 'SOBRE MIM',
        route: '/about-me'
    },
    {
        image: '/assets/img/icons/certificate.svg',
        label: 'CURRÍCULO',
        route: '/resume'
    },
    {
        image: '/assets/img/icons/devices.svg',
        label: 'WEB: APPS E SITES',
        route: '/web'
    },
    {
        image: '/assets/img/icons/ink.svg',
        label: 'DESIGN',
        route: '/design'
    },
    {
        image: '/assets/img/icons/videos.svg',
        label: 'VIDEOS',
        route: '/videos'
    },
    {
        image: '/assets/img/icons/contact.svg',
        label: 'CONTATOS',
        route: '/contacts'
    }
]

export default menuList;